import React from 'react';
import { YEARS, formatProjection } from '../../../helpers';
import { data } from '../../../data';
import './index.scss';

interface SortingDropdownsProps {
  specialitySorting: typeof data.sorting.speciality;
  activeSorting: {
    year: number;
    speciality: string;
    category: string;
  };
  sortingChangeHandler: (type: string, value: number | string) => void;
}

const SortingDropdowns: React.FC<SortingDropdownsProps> = ({
  specialitySorting,
  activeSorting,
  sortingChangeHandler,
}) => {
  const changeSorting = (e) => {
    const { name, value } = e.target;

    sortingChangeHandler(name, value);
  };

  return (
    <div className="sorting-dropdowns responsive-grid">
      <div className="row">
        <div className="col-base year">
          <select name="year" value={activeSorting.year} onChange={changeSorting}>
            {YEARS.map((year) => (
              <option key={`dropdown-year-option-${year}`} value={year}>
                {formatProjection(year)}
              </option>
            ))}
          </select>
        </div>
        <div className="col-base speciality">
          <select name="speciality" value={activeSorting.speciality} onChange={changeSorting}>
            {specialitySorting.map(({ title, value }) => (
              <option key={`dropdown-speciality-option-${value}`} value={value}>
                {title}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SortingDropdowns;
